import React, { useState } from "react";
import DateRangePicker from "./DateRangePicker";
import moment, { Moment } from "moment";
import { useTranslation } from "react-i18next";
import BarGraph from "./BarGraph";

const rangePresets: { [key: string]: [Moment, Moment] } = {
  Today: [moment(), moment()],
  Yesterday: [moment().subtract(1, "days"), moment().subtract(1, "days")],
  "This Week": [moment().startOf("week"), moment().endOf("week")],
  "Last Week": [
    moment().subtract(1, "week").startOf("week"),
    moment().subtract(1, "week").endOf("week"),
  ],
  "Past Two Months": [
    moment().subtract(2, "months").startOf("month"),
    moment(),
  ],
  "This Month": [moment().startOf("month"), moment().endOf("month")],
  "This Year": [moment().startOf("year"), moment().endOf("year")],
  "Last Year": [
    moment().subtract(1, "year").startOf("year"),
    moment().subtract(1, "year").endOf("year"),
  ],
};

const Index = () => {
  const { t } = useTranslation();

  const [startDate, setStartDate] = useState(
    moment().subtract(6, "days").format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState(moment().format("YYYY-MM-DD"));
  const [eventType] = useState("click");
  const [targetName] = useState("Button Weiter");

  const handleRangeChange = (start, end) => {
    setStartDate(start);
    setEndDate(end);
  };

  return (
    <div>
      <h4> {t("analytics:analytics")}</h4>

      <DateRangePicker
        startDate={startDate}
        endDate={endDate}
        onRangeChange={handleRangeChange}
        rangePresets={rangePresets}
      />
      <BarGraph
        startDate={startDate}
        endDate={endDate}
        eventType={eventType}
        targetName={targetName}
      />
    </div>
  );
};

export default Index;
